import { EndpointBuilder } from '@reduxjs/toolkit/query';
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { FeederMasterDataResponse } from '../../types';
import { NFMSFilter } from '../../types/records/feeder-master-data';

export const feederMasterDataEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'nfmsApi'
  >
) => ({
  getFeederMasterListView: builder.mutation<
    FeederMasterDataResponse,
    NFMSFilter
  >({
    query: (data) => ({
      url: `install_feeder_master_data/consumers/`,
      method: 'POST',
      body: data
    }),
    invalidatesTags: []
  })
});
